import styled from 'styled-components';

import { Text } from '@dreryk/react-components';

export const StyledLetterSeparator = styled.div<{ $spacer: boolean }>`
   position: relative;
   width: 100%;
   margin-bottom: 10px;
   ${({ $spacer }) => $spacer && 'visibility: hidden;'}
`;

StyledLetterSeparator.displayName = 'StyledLetterSeparator';

export const StyledLetter = styled(Text)`
   font-weight: bold;
`;

StyledLetter.displayName = 'StyledLetter';

export const StyledLetterSeparatorLine = styled.div`
   position: absolute;
   top: 50%;
   left: 16px;
   width: calc(100% - 16px + 150px);
   margin-top: -2px;
   border-top: 1px dashed ${({ theme }) => theme.borderLight};
`;

StyledLetterSeparatorLine.displayName = 'StyledLetterSeparatorLine';
